module.exports = __webpack_public_path__ + "static/media/VG.709a7d80.svg";